import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue"
import _imports_0 from '@/assets.app/images/twinkle.svg'


const _hoisted_1 = {
  ref: "containerRef",
  class: "firstguide-popup__container"
}
const _hoisted_2 = { class: "firstguide-popup__pane" }
const _hoisted_3 = ["src"]

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import { storage } from '@/helpers/storage'
import { waitTimer } from '@/helpers/timer'
import { backend } from '@/services/backend'
import type { BookFirstGuideInfo } from '@/models/interfaces'
import { StorageKeys } from '@/helpers/storage.keys'

import { Mixpanel } from '@/analytics/mixpanel'
import BookCardBackground from '@/app/components/book/card/BookCardBackground.vue'
import AppButton from '@/app/components/button/AppButton.vue'
import BasePopup from '@/components/ui/BasePopup.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FirstGuidePopup',
  setup(__props) {

const router = useRouter()

const popup = ref<InstanceType<typeof BasePopup> | null>(null)
const suggestion = ref<BookFirstGuideInfo | null>(null)
// This is set when the user has pushed a button or closed the popup.
// Ensures we send exactly one action event.
const popupResolved = ref<boolean>(false)

onMounted(async () => {
  if (
    storage.getItem(StorageKeys.offerGuide) &&
    router.currentRoute.value.path !== '/app/billing'
  ) {
    await displayPopup()
  }
})

async function displayPopup(): Promise<void> {
  // Query the back end for the first guide, and (in parallel) wait
  // one second.
  const result: [BookFirstGuideInfo | null, any] = await Promise.all([
    backend.getExperimentFirstGuide(),
    waitTimer(1000),
  ])

  if (result[0]) {
    suggestion.value = result[0]
    storage.removeItem(StorageKeys.offerGuide)
    popup.value?.show()
    Mixpanel.trackFirstGuideAction(
      suggestion.value.book,
      router.currentRoute.value.path,
      'open',
    )
  }
}

function onStartReading(): void {
  if (suggestion.value) {
    popupResolved.value = true
    popup.value?.hide()

    Mixpanel.trackFirstGuideAction(
      suggestion.value.book,
      router.currentRoute.value.path,
      'read-book',
    )
    router.push({
      name: 'book.page',
      params: {
        url_slug: suggestion.value.book.url_slug,
        page_url_slug: suggestion.value.first_chapter_doc_slug,
      },
    })
  }
}

function onAboutBook(): void {
  if (suggestion.value) {
    popupResolved.value = true
    popup.value?.hide()

    Mixpanel.trackFirstGuideAction(
      suggestion.value.book,
      router.currentRoute.value.path,
      'about-book',
    )
    router.push({
      name: 'book.preview',
      params: {
        url_slug: suggestion.value.book.url_slug,
      },
    })
  }
}

function onClosePopup(): void {
  if (suggestion.value && !popupResolved.value) {
    popupResolved.value = true
    Mixpanel.trackFirstGuideAction(
      suggestion.value.book,
      router.currentRoute.value.path,
      'close',
    )
  }
  // The StorageKeys.offerGuide is already removed, so we shall not see the
  // popup again.
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#appRoot" }, [
    _createVNode(BasePopup, {
      ref_key: "popup",
      ref: popup,
      class: "firstguide-popup",
      onHide: onClosePopup
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            class: "firstguide-popup__sparkle",
            src: _imports_0
          }, null, -1)),
          _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Your first guide is ready", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: suggestion.value?.book.cover_image,
              width: "120",
              height: "160"
            }, null, 8, _hoisted_3),
            _createVNode(AppButton, {
              class: "firstguide-popup__button firstguide-popup--read-btn",
              icon: "iadd",
              onClick: onStartReading
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Start reading ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(AppButton, {
              class: "firstguide-popup__button firstguide-popup--about-btn",
              outlined: true,
              onClick: onAboutBook
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" About book ", -1)
              ]))]),
              _: 1
            }),
            (suggestion.value)
              ? (_openBlock(), _createBlock(BookCardBackground, {
                  key: 0,
                  class: "firstguide-popup__pane-bg",
                  doc: suggestion.value.book
                }, null, 8, ["doc"]))
              : _createCommentVNode("", true)
          ])
        ], 512)
      ]),
      _: 1
    }, 512)
  ]))
}
}

})